import { z } from "zod";

export const schema = z.object({
  pin: z
    .string()
    .min(1, "El PIN es obligatorio")
    .refine((val) => {
      return val.trim().length > 0;
    }, "El PIN no puede estar vacía"),
  user: z
    .string()
    .min(1, "El Usuario es obligatorio")
    .max(255, "La longitud máxima del correo electrónico es de 255 caracteres")
    .nonempty()
    .refine((val) => {
      return val.trim().length > 0;
    }, "El Usuario no puede estar vacío"),
  password: z
    .string()
    .min(1, "La Contraseña es obligatoria")
    .refine((val) => {
      return val.trim().length > 0;
    }, "La Contraseña no puede estar vacía"),
});

export type ConfirmSignature = z.infer<typeof schema>;
